import { styled } from "@styles";

export const BlackHr = styled.hr`
  border-top: 1px solid black;
`;

export const SizedBox = styled.div<{ height?: string; width?: string }>`
  margin-bottom: ${(props) => props.height};
  margin-right: ${(props) => props.width};
`;

export const OpenSansDiv = styled.div`
  text-align: center;
`;

export const PaddingOnly = styled.div<{
  top?: string;
  bottom?: string;
  left?: string;
  right?: string;
}>`
  padding-top: ${(props) => props.top};
  padding-bottom: ${(props) => props.bottom};
  padding-left: ${(props) => props.left};
  padding-right: ${(props) => props.right};
`;

export const PaddingAll = styled.div<{ all: string }>`
  padding: ${(props) => props.all};
`;

export const PaddingSymmetric = styled.div<{
  horizontal?: string;
  vertical?: string;
}>`
  padding-top: ${(props) => props?.vertical ?? 0};
  padding-bottom: ${(props) => props?.vertical ?? 0};
  padding-left: ${(props) => props?.horizontal ?? 0};
  padding-right: ${(props) => props?.horizontal ?? 0};
`;
